import { ChangeDetectionStrategy, Component } from '@angular/core';
import { isSiteEmbedded } from 'src/app/extensions/dot-cms/utils/dot-cms-utils';

@Component({
  selector: 'custom-user-information-mobile',
  templateUrl: './custom-user-information-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomUserInformationMobileComponent {
  constructor() {}

  isInsideIframe(): boolean {
    return isSiteEmbedded();
  }
}
